/** Entity type discriminators for task/contact forms (shared across clients ↔ relations). */
export const CONTACT_TYPE = 1;
export const CLIENT_TYPE = 2;
